<template>
  <div class="tomu-form">
    <div class="tomu-form-header">
      <div class="tomu-form-title">Закажите карту водителя прямо сейчас</div>
    </div>
    <div class="tomu-form-content" @input="validationErrorMessage = null">
      <div class="tomu-form-element">
        <div class="tomu-form-label">Ваше имя:</div>
        <div class="tomu-form-control">
          <input
            v-model="formData.name"
            type="text"
            class="tomu-form-input"
            placeholder="Иванов Иван"
          />
        </div>
      </div>
      <div class="tomu-form-element">
        <div class="tomu-form-label">Ваш телефон:</div>
        <div class="tomu-form-control">
          <input
              @input="handlePhoneInput"
              v-model="formData.phoneNumber"
            type="tel"
            class="tomu-form-input"
            placeholder="+7 (XXX) XXX-XXXX"
          />
        </div>
      </div>
      <div class="tomu-form-element">
        <div class="tomu-form-label">Выберите тип карты:</div>
        <div class="tomu-form-control">
          <select :disabled="digitalDriverCard !== undefined"
                  :class="{ 'bg-gray-100': digitalDriverCard !== undefined}"
            v-model="formData.cardType"
            class="tomu-form-input"
            id="card-type-select"
          >
            <option value="skzi">Карта СКЗИ</option>
          </select>
        </div>
      </div>

      <div v-if="digitalDriverCard" class="tomu-form-element">
        <div class="tomu-form-label">К оплате:</div>
        <div class="tomu-form-control">
          <input
              disabled
              :value="digitalDriverCard.price + ' руб.'"
              type="text"
              class="tomu-form-input bg-gray-100 text-gray-500"
          />
        </div>
      </div>

    </div>
    <div class="tomu-form-footer">
      <p v-if="validationErrorMessage" class="text-red-500">{{ validationErrorMessage }}</p>
      <div class="tomu-form-control">
        <order-card-button-modal
          @card-params-validation-error="handleValidationError"
          v-model:isValid="isValid"
          v-model:cardParams="formData"
        />
        <button
          v-if="close"
          class="
            ml-2
            px-4
            py-2
            ring-1 ring-gray-200
            rounded-md
            bg-gray-200
            hover:bg-gray-300
            transform
            transition-transform
            duration-100
          "
          @click="close"
        >
          Закрыть
        </button>
        <div class="tomu-form-control-description">
          Нажимая кнопку “Оформить карту” Вы даете свое согласие на обработку
          персональных данных
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrderCardButtonModal from "@/components/modals/OrderCardButtonModal";

export default {
  name: "OrderCard",
  components: { OrderCardButtonModal },
  props: {
    close: Function,
    digitalDriverCard: Object,
  },
  data() {
    return {
      formData: {
        name: "",
        phoneNumber: "",
        cardType: this.digitalDriverCard !== undefined ? this.digitalDriverCard.cardType : "skzi",
        digitalDriverCard: this.digitalDriverCard !== undefined ? this.digitalDriverCard.id : null,
      },
      isValid: true,
      validationErrorMessage: null,
    };
  },
  methods: {
    handleValidationError(err) {
      this.validationErrorMessage = err.message;
    },
    handlePhoneInput(event) {
      this.formData.phoneNumber = this.formData.phoneNumber.replaceAll(/[^0-9 \-+]+/g, "")
      this.formData.phoneNumber = this.formData.phoneNumber.replaceAll(/(.)\++/g, "$1")

      if (event.inputType === 'deleteContentBackward' || event.inputType === 'deleteWordBackward' || event.inputType === 'insertFromPaste') {
        return;
      }
      if (this.formData.phoneNumber.startsWith("8")) {
        return;
      }
      if (this.formData.phoneNumber.startsWith("9")) {
        this.formData.phoneNumber = "+7" + this.formData.phoneNumber;
        return;
      }
      if (!this.formData.phoneNumber.startsWith("+")) {
        this.formData.phoneNumber = "+" + this.formData.phoneNumber;
      }
    },
  },
};
</script>

<style scoped>
.tomu-form {
  @apply mx-auto;
  @apply bg-white rounded-md shadow-lg;
  @apply max-w-md;
  @apply space-y-4;
  @apply p-6;

  &-content {
    @apply space-y-4;
  }

  &-footer {
    @apply space-y-4;
  }

  &-title {
    @apply font-bold;
  }

  &-input {
    @apply block w-full;
  }

  &-control {
    &-description {
      @apply mt-1 text-sm text-gray-500;
    }
  }
}
</style>
